"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UploadPartInput_1 = require("./UploadPartInput");
var UploadPartOutput_1 = require("./UploadPartOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.UploadPart = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "UploadPart",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}/{Key+}"
    },
    input: {
        shape: UploadPartInput_1.UploadPartInput
    },
    output: {
        shape: UploadPartOutput_1.UploadPartOutput
    },
    errors: []
};
//# sourceMappingURL=UploadPart.js.map